import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Effect, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { EventActions, MessageActions } from '../actions';
import { ErrorHandlerService } from '../services/index'


/* tslint:disable */
@Injectable()
export class EventEffect {
	constructor(
		private updates$: Actions,
		private eventActions: EventActions,
		private messageActions: MessageActions,
		private errorHandler: ErrorHandlerService
	) { }

	@Effect() updateEventHasVisualQuotaSuccess$ = this.updates$
		.ofType(EventActions.UPDATE_EVENT_HAS_VISUAL_QUOTA_SUCCESS)
		.mapTo(this.messageActions.displayMessage("Die Art des Kontingents wurde erfolgreich geändert!", "success"))
}



// WEBPACK FOOTER //
// ./src/app/effects/event.effect.ts